export default "__VITE_ASSET__DRh2kaSW__"